module.exports = __webpack_public_path__ + "img/w10-b2.b85d3f1f.jpg";